// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-warning[data-v-39194fae] {\n  color: rgb(204 33 40);\n  font-size: 100px;\n}\n.tx-center[data-v-39194fae] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
